module.exports = __webpack_public_path__ + "img/vdvdv.a1902cae.png";